export const PRIMARY_COLOR = "#FC2B2B";
